import { Space } from "antd";
import { ReactNode } from "react";

interface TopCardProps {
  leftChildren?: ReactNode;
  children?: ReactNode;
  size?: number;
  align?: "start" | "end" | "center" | "baseline";
  className?: string;
}

export default function TopCard({
  leftChildren,
  children,
  size = 10,
  align = "center",
  className = "",
}: TopCardProps) {
  return (
    <Space
      wrap={true}
      className={`justify-between bg-white rounded-md border border-extra-light p-4 mb-6 w-full ${className}`}
      size={size}
      align={align}
    >
      <Space wrap={true} size={size}>
        {leftChildren}
      </Space>
      <Space wrap={true} size={size}>
        {children}
      </Space>
    </Space>
  );
}
